/* eslint-disable import/order */
import { jsmWorkItemIncidentRoute } from '@jira/router-routes__jsm-work-item-incident-routes/src/jsmWorkItemIncidentRoute.tsx';
import { jsmWorkItemIncidentEntryPoint } from '@jira/spa-apps__jsm-work-item-incident/src/jsmWorkItemIncidentEntryPoint.entrypoint.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const jsmWorkItemIncidentPageEntrypoint = createPageEntryPoint({
	main: jsmWorkItemIncidentEntryPoint,
});

export const jsmWorkItemIncidentRouteEntry: Route = createEntry(jsmWorkItemIncidentRoute, () => ({
	group: 'servicedesk',

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [...getNavigationResources()],

	entryPoint: () =>
		fg('jsm_aniv_routing_phase_1') ? jsmWorkItemIncidentPageEntrypoint : notFoundPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
